import { getLaborScopeTotalParts } from 'lib/selectors/getScopeTotalParts';
import { getRejectedParts } from 'lib/selectors/getRejectedParts';
import { getScopeNetPartsMade } from 'lib/selectors/getScopeNetPartsMade';
import { createSelector } from 'reselect';
import { getTotalUserAddedManualPartCounts } from './getTotalUserAddedManualPartCounts';

const getProductionPartsDisplay = createSelector(
  [
    getScopeNetPartsMade,
    getRejectedParts,
    getLaborScopeTotalParts,
    getTotalUserAddedManualPartCounts,
  ],
  (
    scopeNetPartsMade,
    rejectedParts,
    laborTicketPartsMade,
    totalUserAddedManualPartCounts
  ) => {
    const displayParts = scopeNetPartsMade + totalUserAddedManualPartCounts;

    return {
      displayParts,
      rejectedParts,
      unsubmittedParts: laborTicketPartsMade,
    };
  }
);

export { getProductionPartsDisplay };
